import React, {
  useEffect,
  useContext,
  useRef,
  useState,
  cloneElement,
} from "react";
import ReactDOM from "react-dom/client";
import { AppContext } from "../context";
import * as tf from "@tensorflow/tfjs";
import {
  PartDetector,
  setBackendExternally,
} from "../partdetection_new/PartDetector";
import { Guidance } from "../guidance_new/GuidanceMain";
import drawArc from "../utils_new/DrawArc";
import carsmall from "../img/carsmall.png";
import initRedImg from "../img/coverage_red.png";
import nearFarArrow from "../img/zizo_arrow.gif";
import Rotate from "./Rotate";
import {
  addImageToList,
  sendCoveredArea,
  setLog,
  lowLightImage,
  actualRegion,
  userLogs,
  patLogs,
  getModel,
  resumeFlowFinalSubmitHandler,
  setImgCOunt,
  translateText,
  getConstraint,
  getAspectRatioClientList,
  getLumaBlurScore,
  getWebpImageFormat,
  getImgQualityFactor,
} from "../context/utils";

import * as constants from "../utils_new/Constants";
import { goodFrame } from "../guidance_new/Stencil";
import { getAngleFromDetections } from "../guidance_new/AngleWIthOrientationRf";
// import ReactGA from "react-ga4";

import Front from "./Stencils/car/Front";
import Front_Isometric_Left from "./Stencils/car/Front-Isometric-Left";
import Front_Isometric_Right from "./Stencils/car/Front-Isometric-Right";
import Side_Left from "./Stencils/car/Side-Left";
import Side_Right from "./Stencils/car/Side-Right";
import Rear from "./Stencils/car/Rear";
import Rear_Isometric_Right from "./Stencils/car/Rear-Isometric-Right";
import Rear_Isometric_Left from "./Stencils/car/Rear-Isometric-Left";

import leftVinArrow from "../img/leftVinArrow.gif";
import RightVInArrow from "../img/RightVInArrow.gif";

import StencilInst from "./Stencils/stenciInst.svg";
import HoldSvg from "./Stencils/hold.svg";

let regionExtraImage = {
  Front: 0,
  "Front-Isometric-Left": 0,
  "Side-Left": 0,
  "Rear-Isometric-Left": 0,
  Rear: 0,
  "Rear-Isometric-Right": 0,
  "Side-Right": 0,
  "Front-Isometric-Right": 0,
};

let regionStencil = {
  Front: Front,
  "Front-Isometric-Left": Front_Isometric_Left,
  "Side-Left": Side_Left,
  "Rear-Isometric-Left": Rear_Isometric_Left,
  Rear: Rear,
  "Rear-Isometric-Right": Rear_Isometric_Right,
  "Side-Right": Side_Right,
  "Front-Isometric-Right": Front_Isometric_Right,
};

const vinRegion = [
  "Front",
  "Front-Isometric-Left",
  "Side-Left",
  "Rear-Isometric-Left",
  "Rear",
  "Rear-Isometric-Right",
  "Side-Right",
  "Front-Isometric-Right",
  "Front",
];
let regionIcon = {
  Front:
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front.svg",
  "Front-Isometric-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+right.svg",
  "Side-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Right.svg",
  "Rear-Isometric-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+right.svg",
  Rear: "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back.svg",
  "Rear-Isometric-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+left.svg",
  "Side-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Left.svg",
  "Front-Isometric-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+left.svg",
};

let logbugs = true;
let regionsAndAnglesMap = {};
for (let val of Object.values(constants.REGIONS))
  regionsAndAnglesMap[val] = new Set();
let allActualRegionDataLog = {};
let allActualRegionDataLogsCheck = {};
let finalRegionsMap = {};
let captured = 0;
let allActualRegionData = {};
let actualGuidanceRegion;
let seconds = 0;
let minutes = 0;
let WholeLightLumaData = "";
let data = {};
let track = null;
let angleDetectedGyro = [];
let currentUploadedPartCount = null;
let detectMlCheck = true;
let imgValue = 0;
let afterFrameimgValue = 0;
let stopRecordingML = false;
let allowImgURLmain = {};
let regionWiseData = {};
let allFrameUpload = false;
let checkOnceRegion = true;
let hold = true;
let currentStencil = "";
let showCoveredRegion = {};
let showCoveredRegioncheck = {};
let staticRegion = "";
let frameUploadStencil = false;
let keepRecord = true;
let captureStencilDial = [];
let imageFrameInterval;
let frameInterval;
let stencilCheckInterval;
let InstructionClear;
let checkLumaValue = true;
let startRefCheck;
let checkImageList = [];
let checkImageList2 = [];
let checkImageList3 = [];
// let previousAngle = -1;
// let previousAngle = [
//   0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180, 195, 210, 225, 240,
//   255, 270, 285, 300, 315, 330, 345, 360,
// ];
let previousAngle = [
  0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170,
  180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320,
  330, 340, 350, 360,
];
let detectionFuncTime = 0;
const StencilVideo = () => {
  const {
    skipStencil,
    setSkipStencil,
    alignStencil,
    setalignStencil,
    capturedStencil,
    setcapturedStencil,
    stepCovered,
    setStepCovered,
    setScreen,
    currentBlock,
    condition,
    setCondition,
    config,
    token,
    mandatory,
    setMandatory,
    inspectionId,
    setStopPing,
    setCurrentPage,
    stopPing,
    restrictUserIfallNotGreen,
    setRestrictUserIfallNotGreen,
    clientId,
    caseId,
    isIOS,
  } = useContext(AppContext);
  const timerRef = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const cardRef = useRef();
  const screen3 = useRef();
  const stencilImageDiv = useRef();
  const loaderGuidanceText = useRef();
  const imgRef = useRef();
  const startRef = useRef();
  const warnRef = useRef();
  const canvas1 = useRef();
  const chooseRegionStencil = useRef();
  const holdImage = useRef();
  const partDetector = new PartDetector();
  const displayText = useRef();
  const rootRef = useRef(null);
  const detectionBox = useRef();
  // const partData = useRef();
  // const partDataValue = useRef();
  // const partDataValueList = useRef();
  const leftNearArrow = useRef();
  const rightNearArrow = useRef();
  const leftFarArrow = useRef();
  const rightFarArrow = useRef();
  const leftArrowVin = useRef();
  const rightArrowVin = useRef();
  const downArrow = useRef();
  const upArrow = useRef();
  const skipDiv = useRef();
  const [mainRegion, setmainRegion] = useState("");
  const [lumacheck, setLumaCheck] = useState(false);
  const guidance = new Guidance(
    config["video-page"]["guidanceMessages"],
    clientId,
    config,
  );
  const confirmSkipDiv = useRef();

  data = {
    text: config["video-page"]["dataText"],
    feedbacks: [],
    regionsCovered: guidance.regionsCoveredMap,
    angle: 0,
    region: "",
    nudges: { partToPoint: "", Nudge: "" },
  };

  showCoveredRegion = guidance.regionsCoveredMap;

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const ua = navigator.userAgent.toLowerCase();
  const isIos = !!/iPhone|iPad|iPod/i.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

  let webCamPromise = null;
  let model = null;
  let active = true;
  let images = [];
  let endTimer = 0;
  let modalFlag = false;
  let startTimer = null;
  let allRegionsCovered = false;
  let allGreen = false;

  let detections = [];

  const isLandscape = () => window.innerWidth > window.innerHeight * 1.2;
  if (logbugs) {
    patLogs("Entered to Video module", inspectionId);
    userLogs({ position: 8, last_page: "video module", inspectionId });
  }
  logbugs = false;

  const sendLogData = async (data) => {
    userLogs(data);
  };

  const getAllFrameUpload = () => {
    return allFrameUpload;
  };

  const uploadImg = (imgURL) => {
    imgValue = imgValue + 1;

    // Create a canvas to draw the star mark
    const img = new Image();
    img.src = imgURL;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const starSize = Math.min(img.width, img.height) * 0.025; // 5% of the image size
      const x = img.width - starSize * 2; // small margin from right
      const y = starSize * 2; // small margin from top
      // drawStar(ctx, x, y, 5, starSize, starSize / 2, "#FFD700", "#FFD700");
      const finalImgURL =
        getWebpImageFormat() && !isIOS
          ? canvas.toDataURL("image/webp", getImgQualityFactor())
          : canvas.toDataURL("image/jpeg");
      let region = Object.keys(config["video-page"]).includes("clientRegion")
        ? config["video-page"]["clientRegion"]
        : "eu-central-1";
      addImageToList({
        name: `${captured}.jpg`,
        imgData: finalImgURL,
        tag: data.region,
        angle: data.angle,
        web_region: data.region,
        env: 1,
        region: region,
        videoData: "",
        dialStatus: finalRegionsMap,
      });
      captured++;
    };
  };

  // const captureImg = (imgURL, detections) => {
  //   imgValue = imgValue + 1;
  //   let frameData = guidance.getFramesToPushStencil(
  //     imgURL,
  //     detections,
  //     stopRecordingML
  //   );
  //   currentUploadedPartCount = frameData["currentUploadedPartCount"];
  //   // allFrameUpload = frameData["allFrameUpload"];
  //   let frames_to_push = [];
  //   if (frameData["framesToPush"].length > 1) {
  //     if (frameData["framesToPush"][0].length > 0) {
  //       afterFrameimgValue = afterFrameimgValue + 1;
  //     }
  //     frames_to_push = frameData["framesToPush"][0];
  //   }
  //   let region = Object.keys(config["video-page"]).includes("clientRegion")
  //     ? config["video-page"]["clientRegion"]
  //     : "eu";
  //   for (let i = 0; i < frames_to_push.length; i++) {
  //     if (
  //       frames_to_push[i] &&
  //       frames_to_push[i].hasOwnProperty("frameEncoded")
  //     ) {
  //       let frameEncoded = frames_to_push[i]["frameEncoded"];
  //       let angle = frames_to_push[i]["angle"];
  //       let web_region = frames_to_push[i]["region"];
  //       let videoData = frames_to_push[i];
  //       delete videoData.frameEncoded;
  //       setGlobalImageQueue({
  //         name: `${captured}.jpg`,
  //         imgData: frameEncoded,
  //         tag: `${web_region}_interim`,
  //         angle,
  //         web_region,
  //         region: region,
  //         videoData: JSON.stringify(frames_to_push[i]),
  //         dialStatus: finalRegionsMap,
  //       });
  //       addImageToList({
  //         name: `${captured}.jpg`,
  //         imgData: frameEncoded,
  //         tag: `${web_region}_interim`,
  //         angle,
  //         web_region,
  //         region: region,
  //         videoData: JSON.stringify(frames_to_push[i]),
  //         dialStatus: finalRegionsMap,
  //       });
  //       captured++;
  //     }
  //   }
  // };

  // const drawStar = (
  //   ctx,
  //   x,
  //   y,
  //   points,
  //   outerRadius,
  //   innerRadius,
  //   fill,
  //   stroke,
  // ) => {
  //   const step = Math.PI / points; // angle increment between each corner (outer/inner)
  //   let angle = -Math.PI / 2; // start at top (−90°)

  //   ctx.beginPath();
  //   for (let i = 0; i < 2 * points; i++) {
  //     const r = i % 2 === 0 ? outerRadius : innerRadius;
  //     const px = x + Math.cos(angle) * r;
  //     const py = y + Math.sin(angle) * r;
  //     if (i === 0) ctx.moveTo(px, py);
  //     else ctx.lineTo(px, py);
  //     angle += step;
  //   }
  //   ctx.closePath();
  //   ctx.fillStyle = fill;
  //   ctx.strokeStyle = stroke;
  //   ctx.lineWidth = 2;
  //   ctx.fill();
  //   ctx.stroke();
  // };

  const uploadImgInterim = (imgURL, variance) => {
    console.log("uploadImgInterim called with variance", `${data.region}_interim_${variance}`);
    imgValue = imgValue + 1;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    addImageToList({
      name: `${captured}.jpg`,
      imgData: imgURL,
      tag: `${data.region}_interim_${variance}`,
      angle: data.angle,
      web_region: data.region,
      region: region,
      env: 1,
      videoData: "",
      dialStatus: finalRegionsMap,
    });
    captured++;
  };

  const captureImgFrame = (byPassBlack) => {
    const cnv = canvasRef.current;
    const vw = videoRef.current;

    if (!vw || vw.videoWidth === 0 || vw.videoHeight === 0) {
      console.log("Video dimensions are not ready.");
      return false;
    }

    cnv.width = vw.videoWidth;
    cnv.height = vw.videoHeight;

    const ctx = cnv.getContext("2d");
    ctx.drawImage(vw, 0, 0);

    const imageData = ctx.getImageData(0, 0, cnv.width, cnv.height);
    const { data, width, height } = imageData;

    let blackPixelCount = 0;
    for (let i = 0; i < data.length; i += 4) {
      const [r, g, b] = [data[i], data[i + 1], data[i + 2]];
      const brightness = (r + g + b) / 3;
      if (brightness < 5) {
        blackPixelCount++;
      }
    }

    const totalPixels = width * height;
    const blackPercentage = (blackPixelCount / totalPixels) * 100;

    return byPassBlack
      ? getWebpImageFormat() && !isIOS
        ? cnv.toDataURL("image/webp", getImgQualityFactor())
        : cnv.toDataURL("image/jpeg")
      : blackPercentage < 100
        ? getWebpImageFormat() && !isIOS
          ? cnv.toDataURL("image/webp", getImgQualityFactor())
          : cnv.toDataURL("image/jpeg")
        : false;
  };

  const setupVideoWithStencilBox = (currentRegion) => {
    const videoEl = videoRef.current;
    if (!videoEl) return;
    requestAnimationFrame(() => {
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;

      const videoAspect = videoEl.videoWidth / videoEl.videoHeight;
      const containerAspect = containerWidth / containerHeight;

      let displayWidth, displayHeight;

      if (videoAspect > containerAspect) {
        displayWidth = containerWidth;
        displayHeight = containerWidth / videoAspect;
      } else {
        displayHeight = containerHeight;
        displayWidth = containerHeight * videoAspect;
      }

      if (stencilImageDiv?.current) {
        const box = stencilImageDiv.current;
        Object.assign(box.style, {
          width: `${displayWidth - 40}px`,
          height: ["Side-Left", "Side-Right"].includes(currentRegion)
            ? `${displayHeight - 45}px`
            : `${displayHeight - 40}px`,
          left: `${(containerWidth - displayWidth) / 2 + 20}px`,
          top: ["Side-Left", "Side-Right"].includes(currentRegion)
            ? `${(containerHeight - displayHeight) / 2 + 22.5}px`
            : `${(containerHeight - displayHeight) / 2 + 20}px`,
          position: "absolute",
          display: "flex",
          pointerEvents: "none",
        });
      }
    });
  };

  const calculateUserPositions = (variable, constant) => {
    const variableIndex = vinRegion.indexOf(variable);
    const constantIndex = vinRegion.indexOf(constant);
    if (variableIndex === -1 || constantIndex === -1) {
      console.log("Invalid variable or constant value", variable, constant);
      return "undefined";
    }
    const totalRegions = vinRegion.length;
    const clockwiseDistance =
      (constantIndex - variableIndex + totalRegions) % totalRegions;
    const counterClockwiseDistance =
      (variableIndex - constantIndex + totalRegions) % totalRegions;
    if (clockwiseDistance === 0 || counterClockwiseDistance === 0) {
      return "same";
    }
    if (clockwiseDistance < counterClockwiseDistance) {
      return "left";
    } else if (counterClockwiseDistance < clockwiseDistance) {
      return "right";
    } else {
      return "left";
    }
  };

  const drawBoxWithDiv = (topLeft, bottomRight, color) => {
    const scaleX = 128 / window.innerWidth;
    const scaleY = 128 / window.innerHeight;

    const originalTopLeft = [
      topLeft[0] / scaleX - window.scrollX,
      topLeft[1] / scaleY - window.scrollY,
    ];

    const originalBottomRight = [
      bottomRight[0] / scaleX - window.scrollX,
      bottomRight[1] / scaleY - window.scrollY,
    ];
    detectionBox.current.style.display = "flex";
    const [x1, y1] = originalTopLeft;
    const [x2, y2] = originalBottomRight;

    const width = x2 - x1;
    const height = y2 - y1;

    // Create a new box div
    const box = document.createElement("div");
    box.style.position = "absolute";
    box.style.left = `${x1}px`;
    box.style.top = `${y1}px`;
    box.style.width = `${width}px`;
    box.style.height = `${height}px`;
    box.style.border = `2px solid ${color}`;
    box.style.boxSizing = "border-box";

    // Append to container
    detectionBox.current.appendChild(box);
  };

  const skipButton = () => {
    setSkipStencil((e) => {
      return [...e, currentStencil];
    });
    clearInterval(imageFrameInterval);
    clearTimeout(stencilCheckInterval);
    stencilCheckInterval = null;
    skipDiv.current.style.display = "none";
    frameUploadStencil = false;
    stencilImageDiv.current.style.display = "none";
    setcapturedStencil((prevCaptured) => {
      const updated = [...prevCaptured, currentStencil];
      setalignStencil((prevAlign) => {
        const alginAndFilterStencil = prevAlign.filter(
          (item) => !updated.includes(item),
        );
        if (updated.length > 1) {
          console.log(alignStencil);
          setmainRegion(alginAndFilterStencil[0]);
          currentStencil = alginAndFilterStencil[0];
        }
        return alginAndFilterStencil;
      });
      if (updated.length === 1) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
      }
      if (updated.length > 7) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
      }
      return updated;
    });
    if (rootRef.current) {
      rootRef.current.unmount();
      rootRef.current = null;
    }
    hold = true;
    stencilCheckInterval = null;
    skipDiv.current.style.display = "none";
    checkLumaValue = true;
  };

  const continueButton = () => {
    hold = true;
    stencilCheckInterval = null;
    skipDiv.current.style.display = "none";
    // checkLumaValue = true;
  };

  const getLumaRes = async (img) => {
    let payload = {
      env: 1,
      region: "eu-central-1",
      inspection_id: inspectionId,
      client_id: clientId,
      image:
        getWebpImageFormat() && !isIOS
          ? img.replace(/^data:image\/webp;base64,/, "")
          : img.replace(/^data:image\/jpeg;base64,/, ""),
    };
    let value = await getLumaBlurScore(payload);
    console.log("luma value", value);
    console.log(
      typeof value === "object",
      value !== null,
      !Array.isArray(value),
      Object.keys(value).length > 0,
      Array.isArray(value[Object.keys(value)[0]]),
      typeof value[Object.keys(value)[0]][1] === "number",
      value[Object.keys(value)[0]][1] < 2,
      !value[Object.keys(value)[0]][1] === 0,
    );
    if (
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length > 0 &&
      Array.isArray(value[Object.keys(value)[0]]) &&
      typeof value[Object.keys(value)[0]][1] === "number" &&
      value[Object.keys(value)[0]][1] < 2 &&
      !value[Object.keys(value)[0]][1] === 0
    ) {
      if (
        chooseRegionStencil.current.style.display === "flex" ||
        skipDiv.current.style.display === "flex"
      ) {
        return;
      }
      setLumaCheck(true);
      // imageFrameInterval = setInterval(() => {
      //   let d = captureImgFrame(false);
      //   if (d) {
      //     uploadImg(d);
      //   }
      // }, 1000);
      // setTimeout(() => {
      //   clearInterval(imageFrameInterval);
      // }, 2000);
      hold = false;
      if (rootRef.current) {
        rootRef.current.unmount();
        rootRef.current = null;
      }
      upArrow.current.style.display = "none";
      downArrow.current.style.display = "none";
      leftFarArrow.current.style.display = "none";
      rightFarArrow.current.style.display = "none";
      leftNearArrow.current.style.display = "none";
      rightNearArrow.current.style.display = "none";
      displayText.current.innerHTML = "";
      displayText.current.style.display = "none";
      holdImage.current.style.display = "none";
      skipDiv.current.style.display = "flex";
    }
  };

  const getMaxItem = (arr) => {
    const freq = {};

    // Count frequency
    for (const item of arr) {
      freq[item] = (freq[item] || 0) + 1;
    }

    // Find max
    let maxItem = null;
    let maxCount = 0;

    for (const item in freq) {
      if (freq[item] > maxCount) {
        maxCount = freq[item];
        maxItem = Number(item);
      }
    }

    return maxItem;
  };

  const updateStencilValue = (
    currentRegion,
    detections,
    realGyroAngle,
    currentAngle,
  ) => {
    if (
      chooseRegionStencil.current.style.display === "flex" ||
      skipDiv.current.style.display === "flex" ||
      confirmSkipDiv.current.style.display === "flex"
    ) {
      return;
    }
    if (checkOnceRegion) {
      checkOnceRegion = false;
      currentStencil = currentRegion;
    }

    let ComponentToRender = regionStencil[currentStencil];
    console.log(currentRegion, currentStencil);
    if (currentRegion && currentStencil) {
      if (checkLumaValue && hold) {
        let imgValue = captureImgFrame(false);
        if (imgValue) {
          checkLumaValue = false;
          getLumaRes(imgValue);
        }
      }

      if (stencilImageDiv.current) {
        stencilImageDiv.current.style.display = "flex";
        setupVideoWithStencilBox(currentRegion);
        if (!rootRef.current) {
          rootRef.current = ReactDOM.createRoot(stencilImageDiv.current);
          rootRef.current.render(<ComponentToRender strokeColor="#fff" />);
        }

        // stencilImageDiv.current.style.border = "2px solid red";
        const rect = stencilImageDiv.current.getBoundingClientRect();
        const scaleX = 128 / window.innerWidth;
        const scaleY = 128 / window.innerHeight;

        const topLeft = [
          (rect.left + window.scrollX) * scaleX,
          (rect.top + window.scrollY) * scaleY,
        ];

        const bottomRight = [
          (rect.right + window.scrollX) * scaleX,
          (rect.bottom + window.scrollY) * scaleY,
        ];
        if (currentRegion === currentStencil) {
          rightArrowVin.current.style.display = "none";
          leftArrowVin.current.style.display = "none";
          if (
            (stencilCheckInterval === undefined ||
              stencilCheckInterval === null) &&
            hold
          ) {
            setLumaCheck(false);
            // setTimeout(() => {
            //   if (
            //     (stencilCheckInterval != undefined ||
            //       stencilCheckInterval != null) &&
            //     !hold
            //   ) {
            //     imageFrameInterval = setInterval(() => {
            //       let c = captureImgFrame(false);
            //       if (c) {
            //         uploadImg(c);
            //       }
            //     }, 1000);
            //   }
            // }, 16000);
            stencilCheckInterval = setTimeout(() => {
              if (chooseRegionStencil.current.style.display === "flex") {
                clearInterval(imageFrameInterval);
                hold = false;
                if (rootRef.current) {
                  rootRef.current.unmount();
                  rootRef.current = null;
                }
                upArrow.current.style.display = "none";
                downArrow.current.style.display = "none";
                leftFarArrow.current.style.display = "none";
                rightFarArrow.current.style.display = "none";
                leftNearArrow.current.style.display = "none";
                rightNearArrow.current.style.display = "none";
                displayText.current.innerHTML = "";
                displayText.current.style.display = "none";
                holdImage.current.style.display = "none";
                skipDiv.current.style.display = "flex";
              }
            }, 18000);
          }
          let value = goodFrame(
            topLeft,
            bottomRight,
            detections,
            currentRegion,
            currentAngle,
          );
          if (detectionBox.current) {
            detectionBox.current.innerHTML = "";
          }
          // if (value["flagValue"] < 3) {
          //   detections.forEach((det) => {
          //     const [x, y, w, h] = det.bbox;
          //     drawBoxWithDiv(
          //       [x * 128, y * 128],
          //       [x * 128 + w * 128, y * 128 + h * 128],
          //       "blue"
          //     );
          //   });
          //   drawBoxWithDiv(value["maskMin"], value["maskMax"], "green");
          //   partDataValue.current.innerHTML = JSON.stringify({
          //     ...value["part_list"],
          //   });
          // }
          if (hold) {
            if (value["flagValue"] === 0) {
              clearTimeout(InstructionClear);
              checkImageList = [];
              hold = false;
              checkLumaValue = true;
              clearTimeout(stencilCheckInterval);
              stencilCheckInterval = null;
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Hold this position for 3 seconds.")
                ? config["video-page"]["Hold this position for 3 seconds."]
                : getTranslateText("Hold this position for 3 seconds.");
              holdImage.current.style.display = "flex";
              setTimeout(() => {
                imageFrameInterval = setInterval(() => {
                  let b = captureImgFrame(false);
                  if (b) {
                    uploadImg(b);
                  }
                }, 300);
              }, 1000);
              setTimeout(() => {
                clearInterval(imageFrameInterval);
                displayText.current.innerHTML = "";
                displayText.current.style.display = "none";
                frameUploadStencil = true;
                holdImage.current.style.display = "none";
                if (rootRef.current) {
                  rootRef.current.unmount();
                  rootRef.current = null;
                }
                captureStencilDial = [...captureStencilDial, currentRegion];
                setTimeout(() => {
                  // if (!rootRef.current) {
                  rootRef.current = ReactDOM.createRoot(
                    stencilImageDiv.current,
                  );
                  rootRef.current.render(
                    <ComponentToRender strokeColor="#90EE90" />,
                  );
                  // }
                }, 200);
                setTimeout(() => {
                  frameUploadStencil = false;
                  stencilImageDiv.current.style.display = "none";
                  setcapturedStencil((prevCaptured) => {
                    const updated = [...prevCaptured, currentRegion];
                    setalignStencil((prevAlign) => {
                      const alginAndFilterStencil = prevAlign.filter(
                        (item) => !updated.includes(item),
                      );
                      if (updated.length > 1) {
                        console.log(alignStencil);
                        setmainRegion(alginAndFilterStencil[0]);
                        currentStencil = alginAndFilterStencil[0];
                      }
                      return alginAndFilterStencil;
                    });
                    if (updated.length === 1) {
                      currentStencil = "";
                      chooseRegionStencil.current.style.display = "flex";
                    }
                    if (updated.length > 7) {
                      currentStencil = "";
                      chooseRegionStencil.current.style.display = "flex";
                    }
                    return updated;
                  });
                  if (rootRef.current) {
                    rootRef.current.unmount();
                    rootRef.current = null;
                  }
                  detectionBox.current.style.display = "none";
                  hold = true;
                }, 1000);
              }, 2000);
            }
            if (value["flagValue"] === 5) {
              checkImageList3.push(value["flagValue"]);
              checkImageList2 = [];
            }
            if (value["flagValue"] === 1 || value["flagValue"] === 2) {
              checkImageList.push(value["flagValue"]);
              checkImageList3 = [];
              checkImageList2 = [];
            }
            if (value["flagValue"] === -1) {
              checkImageList2.push(value["flagValue"]);
            }
            let limit =
              detectionFuncTime < 0.5 ? 7 : detectionFuncTime < 1 ? 5 : 3;
            // partDataValueList.current.innerHTML = `Flag 1&2: ${checkImageList}<br>
            // Flag 5: ${checkImageList3}<br>
            // Flag -1: ${checkImageList2}<br>
            // <br> frame check ${limit}
            // `;
            // console.log(`Flag 1&2: ${checkImageList}<br>
            // Flag 5: ${checkImageList3}<br>
            // Flag -1: ${checkImageList2}<br>
            // <br> frame check ${limit}
            // `);
            if (checkImageList.length > limit) {
              value["flagValue"] = getMaxItem(checkImageList);
              // partDataValueList.current.innerHTML =
              //   partDataValueList.current.innerHTML +
              //   `<br>final flag: ${value["flagValue"]}`;
              // console.log(
              //   partDataValueList.current.innerHTML +
              //     `<br>final flag: ${value["flagValue"]}`
              // );
              if (value["flagValue"] === 1) {
                clearTimeout(InstructionClear);
                upArrow.current.style.display = "none";
                downArrow.current.style.display = "none";
                leftNearArrow.current.style.display = "none";
                rightNearArrow.current.style.display = "none";
                leftFarArrow.current.style.display = "flex";
                rightFarArrow.current.style.display = "flex";
                displayText.current.style.display = "flex";
                displayText.current.innerHTML = Object.keys(
                  config["video-page"],
                ).includes("Move away from the car")
                  ? config["video-page"]["Move away from the car"]
                  : getTranslateText("Move away from the car");
              } else if (value["flagValue"] === 2) {
                clearTimeout(InstructionClear);
                upArrow.current.style.display = "none";
                downArrow.current.style.display = "none";
                leftFarArrow.current.style.display = "none";
                rightFarArrow.current.style.display = "none";
                leftNearArrow.current.style.display = "flex";
                rightNearArrow.current.style.display = "flex";
                displayText.current.style.display = "flex";
                displayText.current.innerHTML = Object.keys(
                  config["video-page"],
                ).includes("Move towards the car")
                  ? config["video-page"]["Move towards the car"]
                  : getTranslateText("Move towards the car");
              } else if (value["flagValue"] === 3) {
                clearTimeout(InstructionClear);
                leftNearArrow.current.style.display = "none";
                rightNearArrow.current.style.display = "none";
                leftFarArrow.current.style.display = "none";
                rightFarArrow.current.style.display = "none";
                downArrow.current.style.display = "none";
                upArrow.current.style.display = "flex";
                displayText.current.style.display = "flex";
                displayText.current.innerHTML = Object.keys(
                  config["video-page"],
                ).includes("Move Up")
                  ? config["video-page"]["Move Up"]
                  : getTranslateText("Move Up");
              } else if (value["flagValue"] === 4) {
                clearTimeout(InstructionClear);
                leftNearArrow.current.style.display = "none";
                rightNearArrow.current.style.display = "none";
                leftFarArrow.current.style.display = "none";
                rightFarArrow.current.style.display = "none";
                upArrow.current.style.display = "none";
                downArrow.current.style.display = "flex";
                displayText.current.style.display = "flex";
                displayText.current.innerHTML = Object.keys(
                  config["video-page"],
                ).includes("Move Down")
                  ? config["video-page"]["Move Down"]
                  : getTranslateText("Move Down");
              }
              if ([1, 2, 3, 4].includes(value["flagValue"])) {
                InstructionClear = setTimeout(() => {
                  upArrow.current.style.display = "none";
                  downArrow.current.style.display = "none";
                  leftFarArrow.current.style.display = "none";
                  rightFarArrow.current.style.display = "none";
                  leftNearArrow.current.style.display = "none";
                  rightNearArrow.current.style.display = "none";
                  displayText.current.style.display = "flex";
                  displayText.current.innerHTML = "";
                }, 3000);
              }
              checkImageList = [];
            }
            if (checkImageList3.length === 4) {
              clearTimeout(InstructionClear);
              checkImageList = [];
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Please adjust your camera to align with the stencils")
                ? config["video-page"][
                    "Please adjust your camera to align with the stencils"
                  ]
                : getTranslateText(
                    "Please adjust your camera to align with the stencils",
                  );
              checkImageList3 = [];
            }
            if (checkImageList2.length === 5) {
              clearTimeout(InstructionClear);
              checkImageList = [];
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes(
                "You're too close or too far — Fit the car edges to the stencil outline",
              )
                ? config["video-page"][
                    "You're too close or too far — Fit the car edges to the stencil outline"
                  ]
                : getTranslateText(
                    "You're too close or too far — Fit the car edges to the stencil outline",
                  );
              checkImageList2 = [];
            }
          }
        } else {
          // if (regionExtraImage[currentStencil] < 2) {
          //   regionExtraImage[currentStencil] =
          //     regionExtraImage[currentStencil] + 1;
          //   setTimeout(() => {
          //     FraudImageUpload();
          //   }, 500);
          // }
          upArrow.current.style.display = "none";
          downArrow.current.style.display = "none";
          leftFarArrow.current.style.display = "none";
          rightFarArrow.current.style.display = "none";
          leftNearArrow.current.style.display = "none";
          rightNearArrow.current.style.display = "none";
          let position = calculateUserPositions(currentRegion, currentStencil);
          switch (position) {
            case "right":
              rightArrowVin.current.style.display = "none";
              leftArrowVin.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Left")
                ? config["video-page"]["Move Left"]
                : getTranslateText("Move Left");
              break;
            case "left":
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Right")
                ? config["video-page"]["Move Right"]
                : getTranslateText("Move Right");
              break;
            case "same":
              break;
            default:
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "none";
              displayText.current.style.display = "none";
              break;
          }
        }
      }
    } else {
      if (stencilImageDiv.current) {
        stencilImageDiv.current.style.display = "none";
      }
    }
  };

  const FraudImageUpload = () => {
    if (!frameUploadStencil) {
      let img = captureImgFrame(false);
      if (img) {
        let region = Object.keys(config["video-page"]).includes("clientRegion")
          ? config["video-page"]["clientRegion"]
          : "eu-central-1";
        region = region === "eu-central-1" ? "eu-central-1" : "ap-south-1";
        addImageToList({
          name: `FroudDetection.jpg`,
          imgData: img,
          tag: "FroudDetection",
          web_region: null,
          env: 1,
          angle: null,
          region: region,
          videoData: null,
          dialStatus: null,
        });
      }
    }
  };

  const filterByLargerBbox = (detections) => {
    const bestDetections = {};
    const keepAll = ["wheel", "window_glass", "headlight", "taillight"]; // parts that should not be filtered

    detections.forEach((det) => {
      const label = det.label;
      const [x, y, w, h] = det.bbox;
      const area = w * h;

      if (keepAll.includes(label)) {
        // Always keep all detections for these labels
        if (!(label in bestDetections)) {
          bestDetections[label] = [];
        }
        bestDetections[label].push({ area, det });
      } else {
        // Apply largest area filter for other labels
        if (!(label in bestDetections)) {
          bestDetections[label] = { area, det };
        } else {
          if (area > bestDetections[label].area) {
            bestDetections[label] = { area, det };
          }
        }
      }
    });

    // Flatten results
    return Object.values(bestDetections).flatMap((entry) =>
      Array.isArray(entry) ? entry.map((e) => e.det) : entry.det,
    );
  };

  const isImageSharp = (base64) => {
    const THRESHOLD = 480;

    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64;

      img.onload = () => {
        if (!img.width || !img.height) return resolve(false);

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Resize width to 500px
        const MAX_W = 500;
        let width = img.width;
        let height = img.height;

        if (width > MAX_W) {
          height = height * (MAX_W / width);
          width = MAX_W;
        }

        width = Math.floor(width);
        height = Math.floor(height);

        if (width < 3 || height < 3) return resolve(false);

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        const { data } = ctx.getImageData(0, 0, width, height);
        const gray = new Float32Array(width * height);

        // Convert to grayscale
        for (let i = 0, j = 0; i < data.length; i += 4, j++) {
          gray[j] = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        }

        let sum = 0;
        let sumSq = 0;

        // Center region: middle 50% of width & height
        const startX = Math.floor(width * 0.25);
        const endX = Math.floor(width * 0.75);
        const startY = Math.floor(height * 0.25);
        const endY = Math.floor(height * 0.75);

        for (let y = startY; y < endY; y++) {
          for (let x = startX; x < endX; x++) {
            const i = y * width + x;
            const val =
              gray[i] * 4 -
              gray[i - 1] -
              gray[i + 1] -
              gray[i - width] -
              gray[i + width];

            sum += val;
            sumSq += val * val;
          }
        }

        const n = (endX - startX) * (endY - startY);
        const variance = n > 0 ? sumSq / n - (sum / n) ** 2 : 0;

        if (variance >= THRESHOLD) {
          uploadImgInterim(base64, variance);
        }
        resolve(variance >= THRESHOLD); // true = sharp, false = blur
      };

      img.onerror = () => resolve(false);
    });
  };

  const detectFrame = async (video, model) => {
    let start = performance.now();
    let end = 0;
    let newImgURL = captureImgFrame();
    if (newImgURL) {
      let detections = [];
      tf.engine().startScope();

      if (detectMlCheck) {
        detectMlCheck = false;
        //cardRef.current.style.display = "none";
        patLogs("part_detection_is_working", inspectionId);
      }
      const processedFrame = partDetector.processInput(video);
      try {
        const predictions = await model.executeAsync(processedFrame);
        detections = partDetector.getDetectionObjects(predictions);
        let [
          currentAngle,
          currentRegion,
          regionsCoveredMap,
          feedbacks,
          videoFreezeStatus,
          currentNudge,
          imgURL,
          allowImgURL,
          frameCountPerRegion,
          // ZoomOutFlag,
          revolutionRegionCurrent,
          realGyroAngle,
          angleRF,
        ] = guidance.performChecksAndGetWarningMessage(
          filterByLargerBbox(detections),
          processedFrame,
          newImgURL,
        );
        // if (imgURL) {
        //     captureImg(imgURL, detections);
        //   } else if (stopRecordingML) {
        //     captureImg(null, null);
        //   }
        data = {
          text: feedbacks[feedbacks.length - 1],
          feedbacks: feedbacks,
          regionsCovered: regionsCoveredMap,
          angle: currentAngle !== -1 ? currentAngle : data.angle,
          region: currentRegion,
          nudges: currentNudge,
        };
        // partData.current.innerHTML = JSON.stringify({
        //   "rf Angle": angleRF,
        //   "normal gyro angle": realGyroAngle,
        //   "new logic gyro angle": data.angle,
        // });
        if (Object.values(regionsCoveredMap).some((value) => value > 0)) {
          if (staticRegion === "") {
            displayText.current.style.display = "none";
            displayText.current.innerHTML = "";
            staticRegion = currentRegion;
            setmainRegion(staticRegion);
          }
          updateStencilValue(
            currentRegion,
            detections,
            realGyroAngle,
            currentAngle,
          );
          // if (previousAngle === -1) {
          //   previousAngle = currentAngle;
          // }
          // if (Math.abs(currentAngle - previousAngle) >= 15) {

          if (previousAngle.includes(currentAngle)) {
            previousAngle = previousAngle.filter(
              (item) => item !== currentAngle,
            );
            let c = captureImgFrame(false);
            if (c) {
              isImageSharp(c);
            }
          }
        }
        captureStencilDial.map((e) => {
          if (Object.keys(showCoveredRegion).includes(e)) {
            showCoveredRegion[e] = 2;
          }
        });
        drawArc(canvas1.current, data.angle, showCoveredRegion, clientId);
        allRegionsCovered = guidance.checkIfAllRegionsCovered();
        finalRegionsMap = showCoveredRegion;
        allowImgURLmain = allowImgURL;
        regionWiseData = frameCountPerRegion;
        actualGuidanceRegion = guidance.actualPartsCoveredMap;
        Object.keys(actualGuidanceRegion).map((e) => {
          allActualRegionDataLog.key = e;
          let takeOutValue = [];
          actualGuidanceRegion[e].forEach((i) => {
            takeOutValue.push(i);
          });
          allActualRegionDataLog[e] = takeOutValue;
        });
        if (!angleDetectedGyro.includes(currentAngle)) {
          angleDetectedGyro.push(currentAngle !== -1 ? currentAngle : 0);
        }
        if (
          JSON.stringify(showCoveredRegion) !==
          JSON.stringify(showCoveredRegioncheck)
        ) {
          sendCoveredArea(
            allGreen,
            showCoveredRegion,
            clientId,
            caseId,
            inspectionId,
          );
          showCoveredRegioncheck = showCoveredRegion;
        }
        if (
          JSON.stringify(allActualRegionDataLog) !==
          JSON.stringify(allActualRegionDataLogsCheck)
        ) {
          allActualRegionDataLog["VideoTimer"] = `${minutes} : ${seconds}`;
          allActualRegionDataLog["angleDetected"] = angleDetectedGyro;
          allActualRegionDataLog["DialStatus"] = showCoveredRegion;
          userLogs({
            position: 3,
            video_data: JSON.stringify(allActualRegionDataLog),
            inspectionId,
          });
          allActualRegionDataLogsCheck = allActualRegionDataLog;
        }
        if (active) requestAnimationFrame(() => detectFrame(video, model));
        tf.engine().endScope();
        end = performance.now();
      } catch (err) {
        end = performance.now();
        let backendErrorPatterns = [
          /gl.*lost/i,
          /webgl.*context/i,
          /compile.*shader/i,
          /link.*shader/i,
          /link.*program/i,
          /vertex.*shader/i,
          /fragment.*shader/i,
          /failed.*shader/i,
          /webgl.*error/i,
          /webgpu/i,
          /device.*lost/i,
          /cannot.*create.*gpu/i,
          /gpu.*error/i,
          /wasm.*memory.*error/i,
          /memory.*access/i,
          /invalid.*memory/i,
          /cpu.*execution.*failed/i,
          /backend.*error/i,
          /backend.*failure/i,
          /tensor.*backend.*error/i,
          /unexpected.*backend/i,
        ];
        console.log("Model execution failed:", err.message);
        console.log("tf.engine().backendName", tf.engine().backendName);
        if (backendErrorPatterns.some((regex) => regex.test(err.message))) {
          const fallbackBackend =
            tf.engine().backendName === "webgl" ? "webgpu" : "cpu";
          const datas = await setBackendExternally(fallbackBackend);
          if (datas) {
            if (active) requestAnimationFrame(() => detectFrame(video, model));
            tf.engine().endScope();
          }
        } else {
          if (active) requestAnimationFrame(() => detectFrame(video, model));
          tf.engine().endScope();
        }
      }
    } else {
      if (active) requestAnimationFrame(() => detectFrame(video, model));
    }
    detectionFuncTime = end - start;
  };

  const checklandScape = () => {
    startRefCheck = setInterval(() => {
      if (!isLandscape()) {
        if (warnRef.current) warnRef.current.style.display = "flex";
        if (startRef.current) startRef.current.style.display = "none";
      } else {
        if (warnRef.current) warnRef.current.style.display = "none";
        if (startRef.current) startRef.current.style.display = "flex";
      }
    }, 200);
  };

  const updateUI = () => {
    if (warnRef.current) {
      warnRef.current.style.display = isLandscape() ? "none" : "flex";
    }
    if (seconds >= 60) {
      minutes++;
      seconds = 0;
    }
    const videoLabel =
      config["video-page"]["Video"] || getTranslateText("Video");
    const secLabel = config["video-page"]["sec"] || getTranslateText("sec");
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    if (timerRef.current) {
      timerRef.current.innerText = `${videoLabel} ${formattedMinutes}:${formattedSeconds} ${secLabel}`;
    }
  };

  const startCamera = () => {
    leftArrowVin.current.style.display = "none";
    rightArrowVin.current.style.display = "none";
    detectionBox.current.style.display = "none";
    holdImage.current.style.display = "none";
    displayText.current.style.display = "none";
    stencilImageDiv.current.style.display = "none";
    chooseRegionStencil.current.style.display = "none";
    upArrow.current.style.display = "none";
    downArrow.current.style.display = "none";
    document.getElementById("window-arc2").style.visibility = "hidden";
    cardRef.current.style.display = "none";
    warnRef.current.style.display = "none";
    imgRef.current.style.display = "block";
    loaderGuidanceText.current.innerHTML = config["video-page"]["loadingText"];
    drawArc(canvas1.current, data.angle, data.regionsCovered, clientId);
    webCamPromise = navigator.mediaDevices
      .getUserMedia(getConstraint(config, clientId))
      .then((stream) => {
        window.stream = stream;
        track = stream.getTracks()[0];
        videoRef.current.srcObject = stream;
        document.getElementById("window-arc2").style.visibility = "visible";
        return new Promise(
          (resolve, _) => (videoRef.current.onloadedmetadata = () => resolve()),
        );
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const startRecording = () => {
    displayText.current.style.display = "flex";
    displayText.current.innerHTML = Object.keys(config["video-page"]).includes(
      "Calculating angle. Please point the camera at the car.",
    )
      ? config["video-page"][
          "Calculating angle. Please point the camera at the car."
        ]
      : getTranslateText(
          "Calculating angle. Please point the camera at the car.",
        );
    patLogs("camera button clicked", inspectionId);
    cardRef.current.style.display = "flex";
    sendLogData({ position: 9, record_button: "yes", inspectionId });
    startRef.current.style.display = "none";
    Promise.all([getModel(), webCamPromise])
      .then((values) => {
        clearInterval(startRefCheck);
        sendLogData({
          position: 6,
          model_initialized: "yes",
          inspectionId,
        });
        model = values[0];
        detectFrame(videoRef.current, values[0]);
        cardRef.current.style.display = "none";
        startTimer = setInterval(() => {
          seconds++;
          endTimer++;
          requestAnimationFrame(() => updateUI());
        }, 1000);
        setCurrentPage("Model initialize");
      })
      .catch((error) => {
        console.log(error);
        sendLogData({
          position: 6,
          model_initialized: `no - ${error.message}`,
          inspectionId,
        });
        setCurrentPage("Model not initialize");
      });
  };

  const stopRecording = async (clicked, submitFlag) => {
    clearInterval(frameInterval);
    sendCoveredArea(allGreen, finalRegionsMap, clientId, caseId, inspectionId);
    if (!typeof actualGuidanceRegion === "undefined") {
      Object.keys(actualGuidanceRegion).map((e) => {
        allActualRegionData.key = e;
        let takeOutValue = [];
        actualGuidanceRegion[e].forEach((i) => {
          takeOutValue.push(i);
        });
        allActualRegionData[e] = takeOutValue;
      });
    }
    allActualRegionData["VideoTimer"] = `${minutes} : ${seconds}`;
    allActualRegionData["angleDetected"] = angleDetectedGyro;
    allActualRegionData["lowLightImage"] = WholeLightLumaData;
    allActualRegionData["DialStatus"] = finalRegionsMap;
    allActualRegionData["currentUploadedPartCount"] = currentUploadedPartCount;
    actualRegion(allActualRegionData, inspectionId);
    setImgCOunt(inspectionId, {
      regionWiseData,
      afterFrameimgValue,
      imgValue,
      ...allowImgURLmain,
      allActualRegionData,
    });
    stopRecordingML = true;
    patLogs("stop recording clicked", inspectionId);
    active = false;
    clearInterval(startTimer);
    window.stream = null;
    track.stop();
    delete allActualRegionData.lowLightImage;
    userLogs({
      position: 3,
      video_data: JSON.stringify(allActualRegionData),
      inspectionId,
    });
    handleNext();
  };

  const back = () => {
    logbugs = true;
    window.stream = null;
    track.stop();
    patLogs("clicked back button", inspectionId);
    if (["opes_prod", "opes_uat"].includes(clientId)) {
      setScreen("menuOpes");
    } else {
      setScreen("menu");
    }
  };

  const handleNext = () => {
    logbugs = false;
    patLogs("video module is completed", inspectionId);
    setTimeout(() => {
      if (currentBlock["mandatory"] && captured > 0) {
        let temp1 = mandatory;
        temp1[currentBlock["id"]] = "completed";
        setMandatory(temp1);
      }
      if (captured > 0) {
        let temp = condition;
        temp[currentBlock["id"]] = "completed";
        setCondition(temp);
        setLog(`${currentBlock["tag"]} was captured`);
        resumeFlowFinalSubmitHandler(currentBlock["id"]);
      }
      if (["opes_prod", "opes_uat"].includes(clientId)) {
        setScreen("menuOpes");
      } else {
        if (Object.keys(config).includes("directModule")) {
          setScreen("success");
        } else {
          setScreen("menu");
        }
      }
    }, 1000);
    // };
  };

  const alignAllStencilAccordingUser = (e, position) => {
    const items = Object.keys(regionStencil);
    const index = items.indexOf(e);
    if (index === -1) {
      return [];
    }
    if (position === "right") {
      return [...items.slice(index), ...items.slice(0, index)];
    } else if (position === "left") {
      const left = items.slice(0, index + 1).reverse();
      const right = items.slice(index + 1).reverse();
      return [...left, ...right];
    } else {
      return [];
    }
  };

  const checkStep = (e) => {
    hold = true;
    if (e === "previous") {
      setalignStencil(
        alignAllStencilAccordingUser(
          Object.keys(regionStencil)[
            Object.keys(regionStencil).indexOf(mainRegion) === 0
              ? 7
              : Object.keys(regionStencil).indexOf(mainRegion) - 1
          ],
          "left",
        ),
      );
      setmainRegion(
        Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 0
            ? 7
            : Object.keys(regionStencil).indexOf(mainRegion) - 1
        ],
      );
      currentStencil =
        Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 0
            ? 7
            : Object.keys(regionStencil).indexOf(mainRegion) - 1
        ];
      console.log(currentStencil);
      chooseRegionStencil.current.style.display = "none";
    } else if (e === "after") {
      setalignStencil(
        alignAllStencilAccordingUser(
          Object.keys(regionStencil)[
            Object.keys(regionStencil).indexOf(mainRegion) === 7
              ? 0
              : Object.keys(regionStencil).indexOf(mainRegion) + 1
          ],
          "right",
        ),
      );
      setmainRegion(
        Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 7
            ? 0
            : Object.keys(regionStencil).indexOf(mainRegion) + 1
        ],
      );
      currentStencil =
        Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 7
            ? 0
            : Object.keys(regionStencil).indexOf(mainRegion) + 1
        ];
      console.log(currentStencil);
      chooseRegionStencil.current.style.display = "none";
    } else if (e === "next") {
      chooseRegionStencil.current.style.display = "none";
    }
  };

  useEffect(() => {
    checklandScape();
    setStopPing(null);
    startCamera();
  }, []);

  return (
    <div
      id="screen3"
      ref={screen3}
      style={{
        position: "relative",
        height: "100dvh",
      }}
    >
      <canvas
        ref={canvasRef}
        id="ios-canvas"
        style={
          getAspectRatioClientList(clientId, config)
            ? {
                width: "100vw",
                height: "100vh",
                objectFit: "contain",
                backgroundColor: "black",
                position: "absolute",
                top: 0,
                left: 0,
              }
            : { position: "absolute", top: 0, left: 0 }
        }
      ></canvas>
      <video
        ref={videoRef}
        id="videoWindow"
        style={
          getAspectRatioClientList(clientId, config)
            ? {
                width: "100vw",
                height: "100vh",
                objectFit: "contain",
                backgroundColor: "black",
                position: "absolute",
                top: 0,
                left: 0,
              }
            : { position: "absolute", top: 0, left: 0 }
        }
        autoPlay
        playsInline
      ></video>
      <div className="video-instructions-stencil">
        <p ref={timerRef}></p>
        <div className="video-instructions-stencil-div">
          <div>
            {Object.keys(config["video-page"]).includes("REC")
              ? config["video-page"]["REC"]
              : getTranslateText("REC")}
          </div>
        </div>
      </div>

      <div id="window-arc2">
        <img src={carsmall} alt="" className="car" />
        <canvas ref={canvas1} width="100" height="100"></canvas>
      </div>

      <div ref={startRef} className="startPopupStecil">
        <div className="startPopupStecilDiv2">
          <img src={StencilInst} />
        </div>
        <div className="startPopupStecilDiv">
          <div>
            <p style={{ fontWeight: 600 }}>
              {Object.keys(config["video-page"]).includes(
                "Circle around the car to record the video and position the car within the stencil to auto capture photos.",
              )
                ? config["video-page"][
                    "Circle around the car to record the video and position the car within the stencil to auto capture photos."
                  ]
                : getTranslateText(
                    "Circle around the car to record the video and position the car within the stencil to auto capture photos.",
                  )}
            </p>
          </div>
          <button onClick={startRecording}>
            {Object.keys(config["video-page"]).includes("GET STARTED")
              ? config["video-page"]["GET STARTED"]
              : getTranslateText("GET STARTED")}
          </button>
        </div>
      </div>

      <div ref={cardRef} id="display-card">
        <div className="pre-start-card">
          <strong
            style={{
              marginRight: "2px",
              fontSize: "12px",
              transform: "rotate(-90deg)",
            }}
          >
            {config["video-page"]["left-text"]}
          </strong>
          <div className="car-flex">
            <strong
              style={{
                marginBottom: "8px",
                textAlign: "center",
                fontSize: "12px",
              }}
            >
              {config["video-page"]["front-text"]}
            </strong>
            <img ref={imgRef} style={{ width: "12dvw" }} src={initRedImg}></img>
            <strong style={{ marginTop: "10px", fontSize: "12px" }}>
              {config["video-page"]["rear-text"]}
            </strong>
          </div>
          <strong
            style={{
              fontSize: "12px",
              transform: "rotate(90deg)",
            }}
          >
            {config["video-page"]["right-text"]}
          </strong>
          <div style={{ width: "20px" }}></div>
        </div>
        <div className="card-info">
          <div>
            <div className="car-green"></div>
            <b
              style={{
                fontSize: "14px",
              }}
            >
              {config["video-page"]["covered-text"]}
            </b>
          </div>
          <div>
            <div
              className="car-red"
              style={{
                backgroundColor: "#de524c",
              }}
            ></div>
            <b
              style={{
                fontSize: "14px",
              }}
            >
              {config["video-page"]["notcovered-text"]}
            </b>
          </div>
          <div className="card-note">
            <p
              ref={loaderGuidanceText}
              style={{ width: "100%", fontSize: "14px" }}
            ></p>
            <img
              id="model-loader"
              src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/video_model_loader.gif"
              alt="abc"
            />
          </div>
        </div>
      </div>

      <div className="chooseRegionStencil" ref={chooseRegionStencil}>
        {skipStencil.length > 0 ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "These sections were missed.",
            )
              ? config["video-page"]["These sections were missed."]
              : getTranslateText("These sections were missed.")}
          </h3>
        ) : capturedStencil.length > 7 ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "All sides of the car is captured",
            )
              ? config["video-page"]["All sides of the car is captured"]
              : getTranslateText("All sides of the car is captured")}
          </h3>
        ) : (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Select left or right to move around the car.",
            )
              ? config["video-page"][
                  "Select left or right to move around the car."
                ]
              : getTranslateText(
                  "Select left or right to move around the car.",
                )}
          </h3>
        )}
        {skipStencil.length > 0 && (
          <div className="missedList">
            <ul className="missedListUl">
              {skipStencil.map((e, index) => (
                <li key={index}>
                  {Object.keys(config["video-page"]["region"]).includes(e)
                    ? config["video-page"]["region"][e]
                    : getTranslateText(e)}
                </li>
              ))}
            </ul>
          </div>
        )}
        {capturedStencil.length > 7 ? (
          <div
            className="StopRecording"
            onClick={() => {
              stopRecording();
            }}
          >
            <p>
              {Object.keys(config["video-page"]).includes("Proceed")
                ? config["video-page"]["Proceed"]
                : getTranslateText("Proceed")}
            </p>
          </div>
        ) : (
          <div className="regionModule">
            <div
              className="regionModuleDiv"
              onClick={() => {
                checkStep("previous");
              }}
            >
              <img
                src={
                  regionIcon[
                    Object.keys(regionStencil)[
                      Object.keys(regionStencil).indexOf(mainRegion) === 0
                        ? 7
                        : Object.keys(regionStencil).indexOf(mainRegion) - 1
                    ]
                  ]
                }
                className="regionModuleimg"
                style={{ border: "1px solid black" }}
              />
              <div className="regionButton">
                <img
                  ref={leftArrowVin}
                  style={{
                    height: "18px",
                    width: "30px",
                    transform: "rotate(-180deg)",
                  }}
                  src={nearFarArrow}
                />
                <p>
                  {Object.keys(config["video-page"]).includes("Left")
                    ? config["video-page"]["Left"]
                    : getTranslateText("Left")}
                </p>
              </div>
            </div>
            <div className="regionModuleDiv">
              <img
                src={regionIcon[mainRegion]}
                style={{ border: "2px solid #13da0e" }}
                className="regionModuleimg"
              />
              <h3 style={{ width: "100%", marginTop: "10%" }}>
                {Object.keys(config["video-page"]["region"]).includes(
                  mainRegion,
                )
                  ? config["video-page"]["region"][mainRegion]
                  : getTranslateText(mainRegion)}
              </h3>
            </div>

            <div
              className="regionModuleDiv"
              onClick={() => {
                checkStep("after");
              }}
            >
              <img
                className="regionModuleimg"
                src={
                  regionIcon[
                    Object.keys(regionStencil)[
                      Object.keys(regionStencil).indexOf(mainRegion) === 7
                        ? 0
                        : Object.keys(regionStencil).indexOf(mainRegion) + 1
                    ]
                  ]
                }
                style={{ border: "1px solid black" }}
              />
              <div className="regionButton">
                <p>
                  {Object.keys(config["video-page"]).includes("Right")
                    ? config["video-page"]["Right"]
                    : getTranslateText("Right")}
                </p>
                <img
                  ref={rightArrowVin}
                  style={{
                    height: "18px",
                    width: "30px",
                  }}
                  src={nearFarArrow}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div ref={warnRef} id="warn-card">
        <Rotate />
        <p className="note">{config["video-page"]["rotateText"]}</p>
      </div>

      <div className="stencil" ref={stencilImageDiv}></div>
      <img src={HoldSvg} className="holdImage" ref={holdImage} />
      <div className="displayText" ref={displayText}>
        <p></p>
      </div>
      <div
        style={{ position: "relative", height: "100vh", width: "100vw" }}
        ref={detectionBox}
      ></div>
      {/* <p
        style={{
          position: "absolute",
          top: "30px",
          left: 0,
          backgroundColor: "white",
          padding: "5px",
        }}
        ref={partData}
      ></p> */}
      {/* <p
        style={{
          position: "absolute",
          top: "50px",
          left: 0,
          backgroundColor: "transparent",
          color: "red",
          padding: "5px",
        }}
        ref={partDataValue}
      ></p> */}
      {/* <p
        style={{
          position: "absolute",
          top: "150px",
          left: 0,
          backgroundColor: "transparent",
          color: "blue",
          padding: "5px",
        }}
        ref={partDataValueList}
      ></p> */}
      {capturedStencil.length > 0 &&
        capturedStencil.length < 8 &&
        chooseRegionStencil.current.style.display === "none" && (
          // <button
          //   style={{
          //     borderRadius: "3px",
          //     border: "none",
          //     backgroundColor: "#007aff",
          //     color: "white",
          //     fontSize: "16px",
          //     width: "auto",
          //     height: "33px",
          //     position: "absolute",
          //     top: "50px",
          //     right: "10px",
          //     padding: "0px 5px"
          //   }}
          //   onClick={() => {
          //     skipButton();
          //   }}
          // >
          //   Skip capture
          // </button>
          <button
            className="skip-btn"
            onClick={() => {
              confirmSkipDiv.current.style.display = "flex";
            }}
          >
            <span className="skip-text">
              {Object.keys(config["video-page"]).includes("Skip this region")
                ? config["video-page"]["Skip this region"]
                : getTranslateText("Skip this region")}
            </span>
            <span className="skip-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 6 L12 12 L6 18"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 6 L18 12 L12 18"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <rect x="19" y="5" width="2" height="14" rx="1" fill="white" />
              </svg>
            </span>
          </button>
        )}
      <img ref={leftNearArrow} className="leftNearArrow" src={nearFarArrow} />
      <img ref={rightNearArrow} className="rightNearArrow" src={nearFarArrow} />
      <img ref={leftFarArrow} className="leftFarArrow" src={nearFarArrow} />
      <img ref={rightFarArrow} className="rightFarArrow" src={nearFarArrow} />
      <img
        ref={leftArrowVin}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-180deg) translate(50%, 50%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />

      <img
        ref={rightArrowVin}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "translate(-50%, -50%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />
      <img
        ref={upArrow}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-90deg) translate(20%, -120%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />

      <img
        ref={downArrow}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-270deg)translate(-20%, -120%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />
      <div ref={confirmSkipDiv} className="skipDiv">
        <h3>
          {Object.keys(config["video-page"]).includes(
            "Are you sure you want to skip this section?",
          )
            ? config["video-page"][
                "Are you sure you want to skip this section?"
              ]
            : getTranslateText("Are you sure you want to skip this section?")}
        </h3>
        <div className="skipDivButtons">
          <div
            onClick={() => {
              confirmSkipDiv.current.style.display = "none";
              skipButton();
            }}
          >
            {Object.keys(config["video-page"]).includes("Yes")
              ? config["video-page"]["Yes"]
              : getTranslateText("Yes")}
          </div>
          <div
            onClick={() => {
              confirmSkipDiv.current.style.display = "none";
            }}
          >
            {Object.keys(config["video-page"]).includes("No")
              ? config["video-page"]["No"]
              : getTranslateText("No")}
          </div>
        </div>
      </div>
      <div ref={skipDiv} className="skipDiv">
        {lumacheck ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region.",
            )
              ? config["video-page"][
                  "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region."
                ]
              : getTranslateText(
                  "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region.",
                )}
          </h3>
        ) : (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region.",
            )
              ? config["video-page"][
                  "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region."
                ]
              : getTranslateText(
                  "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region.",
                )}
          </h3>
        )}
        <div className="skipDivButtons">
          <div
            onClick={() => {
              continueButton();
            }}
          >
            {Object.keys(config["video-page"]).includes("Retry")
              ? config["video-page"]["Retry"]
              : getTranslateText("Retry")}
          </div>
          <div
            onClick={() => {
              skipButton();
            }}
          >
            {Object.keys(config["video-page"]).includes("Skip")
              ? config["video-page"]["Skip"]
              : getTranslateText("Skip")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StencilVideo;
